import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/9.mp3"
export default function P1() {
    return (
        <MainLayout
        title="Knajpa Łukaszewskiego"     
        question="" 
            audio={audio}
        answers={{
            ans1: "Poproszę cymes.",
            ans2: "Spróbujmy lodów!",    
        }}
        links={{
            link1: PAGES.p22,
            link2: PAGES.p23,
        }}
        content={
            <div>
                <p>
                Chociaż jest poniedziałek, w knajpie jest mnóstwo ludzi. Rzeczywiście, tak jak mówił Emil, niektórzy są ubrani w tradycyjne żydowskie kapelusze. Knajpa stoi też niedaleko synagogi, co zapewnia jej wielu gości.
                </p>
                <ul>
                    <li>O, patrz, jest i stary Kulawinek z synem – szturcha cię Emil. Patrzysz na mężczyznę o sumiastym wąsie, który dyskutuje z młodym chłopcem. – Zobaczysz, tato, ja kiedyś napiszę książkę! – odgraża się malec. Emil mruga do ciebie porozumiewawczo:</li>
                    <li>Ciągle wypytuje o historię, mądry chłopak!</li>
                </ul>
                <p>
                Zajmujecie ostatni wolny stół i zamawiacie: dla Emila gęś z kaszą jaglaną, a dla ciebie – wyśmienitego faszerowanego indyka, specjalność lokalu. Po posiłku podchodzi do was sam właściciel – Franciszek Łukaszewski.
                </p>
                <ul>
                    <li>No panowie, wszystko smakuje? Na deser dziś mamy cymesik albo lody prosto od „Pikusia” Chłodnickiego! </li>
                    <li>Niech gość zadecyduje. Bierz, na co masz ochotę! – mówi Emil.</li>
                </ul>
            </div>
        }
        />
        
            );
}